import { ComponentProps, FC, useMemo } from 'react'
import { FloatingPaneFooter } from 'components/features/pfm/FloatingPaneFooter/FloatingPaneFooter'
import { FloatingPaneHeader } from 'components/features/pfm/FloatingPaneHeader/FloatingPaneHeader'
import { FloatingPaneLayout } from 'components/features/pfm/FloatingPaneLayout/FloatingPaneLayout'
import { PAGE_FILTER_PANE } from 'components/features/pageFilters/types'
import { useFlexClassNames } from 'hooks/useClassNames'
import { IS_MOBILE } from 'helpers/userAgentHelpers'

type FilterFloatingPanePresetProps =
& Omit<ComponentProps<typeof FloatingPaneHeader>, 'name'>
& ComponentProps<typeof FloatingPaneFooter>
& {
  title: string
}
export const FilterFloatingPanePreset: FC<FilterFloatingPanePresetProps> = (props) => {
  const { children, title, subTitle, iconSlug, progressBarPercent, onCancel, compact, actionName, onAction, onClose, actionDisabled } = props
  const flexClassNames = useFlexClassNames({ padding: 'medium', gap: 'medium', alignRight: true })

  const headerChild = useMemo(() => (
    <FloatingPaneHeader
      title={ title }
      subTitle={ subTitle }
      iconSlug={ iconSlug }
      progressBarPercent={ progressBarPercent }
      onClose={ onCancel || onClose || undefined }
      compact={ compact }
    />
  ), [compact, iconSlug, onCancel, onClose, progressBarPercent, subTitle, title])

  const footerChild = useMemo(() => {
    return (
      <FloatingPaneFooter
        actionName={ actionName }
        actionDisabled={ actionDisabled }
        onAction={ onAction }
        onCancel={ !IS_MOBILE ? onClose : undefined }
      />
    )
  }, [actionDisabled, actionName, onAction, onClose])

  return (
    <FloatingPaneLayout
      type={ PAGE_FILTER_PANE }
      header={ headerChild }
      footer={ footerChild }
      bodyClassName={ flexClassNames }
      onClose={ onClose }
      multiCardLayout
      verticallySpreadLayout
    >
      { children }
    </FloatingPaneLayout>
  )
}
